import { render } from "./transactions-page.vue?vue&type=template&id=7783ab00&ts=true"
import script from "./transactions-page.ts?vue&type=script&lang=ts"
export * from "./transactions-page.ts?vue&type=script&lang=ts"

import "./transactions-page.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__